import {Component, Input} from '@angular/core';
import { BaseGridComponent } from '@base/component/BaseGridComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import {BaseState, CredentialInfo, UserActivityStatus} from '@m4u-angular/base/entities/BaseEntities';
import { DateHelpers } from '@core/helpers/DateHelpers';
import { ContextMenuElement } from '@m4u-angular/base/classes/BaseClasses';

@Component({
    providers: ServiceBagServices,
    selector: 'app-useractivitystatus-grid',
    templateUrl: './useractivitystatus-grid.component.html',
    styleUrls: ['./useractivitystatus-grid.component.scss']
})
export class UserActivityStatusGridComponent extends BaseGridComponent<UserActivityStatus, BaseState>
{
    @Input() CredentialsInfo: CredentialInfo[];
    
    constructor(A: ServiceBagService) {
        super(A, 'UserActivityStatusGridComponent', UserActivityStatus, BaseState);
    }

    OnGetLastUsedBeforeText(rowData): string
    {
        return DateHelpers.GetDateApproximate((rowData as UserActivityStatus).LastUseDate, false)
    }

    protected override GetGridRowContextMenu(options?: any): ContextMenuElement[] {
        return [{
            text: this.RC('btnGoToLoginHistory'),
            visible: true,
            onClick: () => this.OnGoToLoginHistory(options)
        },{
            text: this.RC('btnGoToRequestsHistory'),
            visible: true,
            onClick: () => this.OnGoToRequestsHistory(options)
        }];
    }

    private OnGoToLoginHistory(options) {
        console.log(options);
        this.Navigate(['pages/general/user-login-history'], { CredentialID: options.data.CredentialID });
    }

    private OnGoToRequestsHistory(options) {
        console.log(options);
        this.Navigate(['pages/general/requests-history'], { CredentialID: options.data.CredentialID });
    }
}
